<!-- ------------------------------------------------------>
<!-- Displays one "Verlauf", that is one part of a track -->
<!-- ------------------------------------------------------>

<template>
  <!-- sm  and up layout (table) -->
  <div :id="item.rowId" :style="{ background: item.bgColor }" :class="containerClasses" class="d-flex flex-row verlauf font-size" @click="$emit('click')">
    <div class="point pl-2">
      <time-line-point :bottomConnection="!item.end && !isLastItem" :cellHeight="43" :small="!item.start && !item.end" :themeName="themeName"></time-line-point>
    </div>
    <!-- <div class="location">{{ ort.longname }}</div> -->
    <div class="d-flex" :class="{ bold: bold }">
      {{ item.location }}
      <v-menu v-if="displayJsonPopUp" rounded offset-y>
        <template v-slot:activator="{ attrs, on }">
          <v-btn v-bind="attrs" v-on="on" icon style="transform: translateY(-8px)">
            <v-icon small color="gray" v-bind="attrs" v-on="on"> mdi-information-outline</v-icon>
          </v-btn>
        </template>
        <div style="background: white" class="pa-2">
          <pre><code>{{ JSON.stringify(item, null, 2) }}</code></pre>
        </div>
      </v-menu>
    </div>
    <template v-for="col in perlschnurColumns">
      <div v-if="col.key === 'abbr'" :key="col.key" class="abbreviation">{{ item.abbreviation }}</div>
      <div v-if="col.key === 'line'" :key="col.key" class="line">{{ item.line }}</div>
      <div v-if="col.key === 'kurs'" :key="col.key" class="track">{{ item.track }}</div>
      <div v-if="col.key === 'custom1'" :key="col.key" class="zone">{{ item.custom1 }}</div>
      <div v-if="col.key === 'zone'" :key="col.key" class="zone">{{ item.zone }}</div>
    </template>

    <div class="an" v-if="item.end || item.an !== item.ab" :id="`TE_${item.ab}`" :class="{ bold: bold }">
      <!--{{ getLocalTimeFromMinutesAfterMidnight(item.an) }}-->
      {{ item.anFormatted }}
    </div>
    <div class="an" v-else></div>

    <div class="ab" v-if="!item.start && item.end" :id="`TLAST_${item.ab}`"></div>
    <div class="ab" v-else :id="`T_${item.ab}`" :class="{ bold: bold }">
      <!--{{ getLocalTimeFromMinutesAfterMidnight(item.ab) }}-->
      {{ item.abFormatted }}
    </div>

    <div class="notice-and-connection d-flex flex-column flex-grow-1">
      <div class="notice d-flex flex-row align-start">
        <div v-if="item.comment && item.comment.length > 50" class="d-flex">
          <v-menu elevation="3" color="gray" v-model="showComment" max-width="300" :close-on-content-click="true" transition="slide-y-transition">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" v-html="item.comment"></div>
            </template>
            <v-card>
              <div class="pa-5 notice" v-html="item.comment"></div>
            </v-card>
          </v-menu>
          <v-btn small icon @click="showComment = true" class="ml-2">
            <v-icon color="grey"> mdi-dots-vertical</v-icon>
          </v-btn>
        </div>
        <div v-else v-html="item.comment" class="comment"></div>
      </div>
      <div class="connection">
        <anschluss v-if="item.connection" :anschluss="item.connection" :fahrtDateAsTime="item.fahrtDateAsTimeInMs"></anschluss>
      </div>
    </div>
  </div>
</template>

<script>
import Anschluss from './Anschluss';
import TimeLinePoint from './TimeLinePoint.vue';
import dateUtils from '@/common/dateUtils';

export default {
  name: 'Verlauf-common',

  components: {
    Anschluss,
    TimeLinePoint,
  },
  props: {
    item: Object,
    perlschnurColumns: Array,
    configuredTimeFormat: String,
    themeName: String,
    isLastItem: Boolean,
    isHighlighted: Boolean,
    displayJsonPopUp: { type: Boolean, default: false },
    dateString: String,
  },
  data() {
    return {
      showComment: false,
    };
  },
  computed: {
    bold() {
      return this.item.end === true || this.item.start === true;
    },
    containerClasses() {
      let clz;

      if (this.isHighlighted) {
        clz += ` marked-row--${this.themeName}`;
      }
      return clz;
    },
  },
  methods: {
    getLocalTimeFromMinutesAfterMidnight(minutesAfterMidnight) {
      return dateUtils.getTimeFromMinutesAfterMidnight(this.configuredTimeFormat, minutesAfterMidnight, this.dateString);
    },
  },
};
</script>
<style lang="scss">
@import './perlschnur.scss';
</style>
